module.exports = __webpack_public_path__ + "static/media/kiwi-grocery-logo.2b59e463.png";